import {
  DCPOrderConfirmationCtaDTO,
  DCPPartialOrderDTO,
  SMSAddress,
  SMSDeliveryMode,
  SMSOrder,
  SMSOrderEntry,
  SMSPaymentModeDTO,
  SMSPointOfService,
  SMSPrice,
} from '@dh-io-emh/commerce-api/src/models/shared/ocb/api.schema';

export enum PaymentMode {
  FinancialService = 'FINANCIAL_SERVICE',
  DirectPayment = 'DIRECT_PAYMENT',
  OtherPayment = 'OTHER_PAYMENT',
}

export default class Order {
  code: string;
  contactAddress?: SMSAddress;
  cta?: DCPOrderConfirmationCtaDTO;
  deliveryCost?: SMSPrice;
  downstreamPaymentMode: PaymentMode;
  entries?: SMSOrderEntry[];
  financialCalculatorProductType?: string;
  financialCalculatorStorageId?: string;
  paymentAddress?: SMSAddress;
  paymentMode?: SMSPaymentModeDTO;
  partialOrderList?: DCPPartialOrderDTO[];
  customerType: string;
  net?: boolean;
  guid?: string;
  pickupPointOfService?: SMSPointOfService;

  constructor(data: SMSOrder) {
    this.code = data.code as string;
    this.contactAddress = data.contactAddress;
    this.cta = data?.cta;
    this.deliveryCost = data?.deliveryCost;
    this.paymentAddress = data?.paymentAddress;
    this.paymentMode = data?.paymentMode;
    this.customerType = data.dcpCustomerClassification?.businessModel as string;
    this.net = data.net;
    this.downstreamPaymentMode = data.downstreamPaymentMode as PaymentMode;
    this.financialCalculatorProductType = (data.financialCalculatorProductType || '').toLowerCase();
    this.financialCalculatorStorageId = data?.financialCalculatorStorageId;
    this.partialOrderList = data?.partialOrderList;
    this.guid = data?.guid;
    this.entries = data?.entries;
    this.pickupPointOfService = data?.pickupPointOfService;
  }

  static create(data: SMSOrder) {
    return new Order(data);
  }
}
